import { neutral, Text } from "@flat-ui";
import { Box, Stack, SvgIconProps } from "@mui/material";

interface Props {
  /** Icon component rendered in the page header */
  source: (props: SvgIconProps) => JSX.Element;

  /** The title to display */
  title: string;

  /** The subtitle to display */
  subtitle?: string;
}

/** Component to display general information of the projects map */
export function ProjectsMapInfoPage({
  title,
  subtitle,
  source,
}: Props): JSX.Element {
  const Icon = source;

  return (
    <Stack
      sx={{
        height: "100%",
        width: "100%",
        backgroundColor: neutral[50],
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "16px",
      }}
    >
      <Box
        sx={{
          backgroundColor: neutral[0],
          borderRadius: "50%",
          width: "80px",
          height: "80px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Icon
          aria-hidden="true"
          sx={{
            height: "40px",
            width: "40px",
          }}
        />
      </Box>
      <Text
        variant="heading24"
        sx={{
          marginTop: "16px",
        }}
      >
        {title}
      </Text>
      {subtitle && (
        <Text
          variant="bodyL"
          sx={{
            marginTop: "16px",
            color: neutral[600],
          }}
        >
          {subtitle}
        </Text>
      )}
    </Stack>
  );
}
